import styled from 'styled-components';

export const Badge = styled.span<{
  variant?: 'success' | 'warning' | 'error' | 'info' | 'normal';
  size?: 'sm' | 'md';
}>`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
  padding: ${({ size = 'md', theme }) =>
    size === 'sm'
      ? `${theme.spacing.xs} ${theme.spacing.sm}`
      : `${theme.spacing.xs} ${theme.spacing.md}`};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  font-size: ${({ size = 'md', theme }) =>
    size === 'sm' ? theme.typography.fontSize.xs : theme.typography.fontSize.sm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  white-space: nowrap;

  ${({ variant = 'normal', theme }) => {
    const colorMap = {
      success: theme.colors.status.success,
      warning: theme.colors.status.warning,
      error: theme.colors.status.error,
      info: theme.colors.status.info,
      normal: theme.colors.alert.normal,
    };

    const bgColor = colorMap[variant];
    const isWarning = variant === 'warning';

    return `
      background: ${bgColor}${isWarning ? '30' : '20'};
      color: ${isWarning ? theme.colors.text.primary : bgColor};
    `;
  }}
`;

export const StatusBadge = styled(Badge)<{ $status?: 'active' | 'inactive' }>`
  ${({ $status = 'active', theme }) => {
    if ($status === 'active') {
      return `
        background: ${theme.colors.status.success}20;
        color: ${theme.colors.status.success};
      `;
    }
    return `
      background: ${theme.colors.text.muted}20;
      color: ${theme.colors.text.muted};
    `;
  }}
`;

export const AlertBadge = styled(Badge)<{ level?: 'normal' | 'attention' | 'urgent' }>`
  ${({ level = 'normal', theme }) => {
    const colorMap = {
      normal: theme.colors.alert.normal,
      attention: theme.colors.alert.attention,
      urgent: theme.colors.alert.urgent,
    };

    const bgColor = colorMap[level];
    const isAttention = level === 'attention';

    return `
      background: ${bgColor}${isAttention ? '30' : '20'};
      color: ${isAttention ? theme.colors.text.primary : bgColor};
    `;
  }}
`;
